import { useOptimizelyExperiment } from '@zoopla/optimizely';

export const useSearchBarExperiment = () => {
    const [recentLocationsExperiment] = useOptimizelyExperiment(
        'sr-1932_display_recent_locations'
    );

    return recentLocationsExperiment === 'variation_2';
};
